module.exports = __webpack_public_path__ + "static/media/dodgem(14).0bb90fe9.PNG";